"use client";

import React, { createContext, useContext, ReactNode } from "react";

interface SystemConfig {
    canAddToQuote: boolean;
    canPurchase: boolean;
    enableOrderBySku: boolean;
    showSKU: boolean;
    showInventory: boolean;
}

const SystemConfigContext = createContext<SystemConfig | undefined>(undefined);

export const SystemConfigProvider = ({ children, value }: { children: ReactNode; value: SystemConfig }) => {
    return <SystemConfigContext.Provider value={value}>{children}</SystemConfigContext.Provider>;
};

export const useSystemConfig = () => {
    const context = useContext(SystemConfigContext);
    if (!context) {
        throw new Error("useSystemConfig must be used within a SystemConfigProvider");
    }
    return context;
};
